

<body class="mat-app-background">
    <div class="container-fluid m-0 p-0" [ngClass]="{'dark-theme': isDark}">
        <!-- Panel flotante de control -->
        <div class="floating-control-panel" (mouseenter)="expandirDiv()" (mouseleave)="contraerDiv()" 
             [ngClass]="{'expanded': mouseSobreDiv}">
            <div class="panel-toggle">
                <mat-icon>{{mouseSobreDiv ? 'chevron_left' : 'menu'}}</mat-icon>
            </div>
            <div class="panel-content">
                <h6 class="panel-title mb-2">Paneles</h6>
                <div class="panel-option">
                    <mat-checkbox [checked]="rastreador" (change)="showTab('rastreador')" [color]="'primary'">
                        Rastreador
                    </mat-checkbox>
                </div>
                <div class="panel-option">
                    <mat-checkbox [checked]="modeloDiv" (change)="showTab('lista')" [color]="'primary'">
                        Lista Compañía
                    </mat-checkbox>
                </div>
            </div>
        </div>

        <div class="row p-0 m-0" #rowContainer>
            <div class="col-md-2 p-0 m-0 resizable-column" style="height: 90%;" #column3 *ngIf="rastreador" (mousedown)="startResizing($event, column3)"
                style="width: 400px;">
                <mat-card class="mb-25 enrolled-created-box ccorbit-card no-scrollbar">
                    <mat-card-content class="">
                        <h5 class="etiquetas">Rastreador</h5>
                            <app-crear-modelo
                                [fechaInicial]="Modelformdata.fechaInicioString"
                                [frecuencySelect]="frecuencySelect"
                                [selectedFrecuency]="selectedFrecuency"
                                [mercados]="mercados"
                                [selectedIdMercado]="selectedIdMercado"
                                [planificadorsv]="planificadorsv"
                                [companiasIndice]="companiasIndice"
                                [companiasVolatilidad]="companiasVolatilidad"
                                [idMercadoIndice]="idMercadoIndice"
                                [idActivoIndice]="idActivoIndice"
                                [idMercadovolatilidad]="idMercadovolatilidad"
                                [idActivoVolatilidad]="idActivoVolatilidad"
                                [bajista]="bajista"
                                [periodico]="periodico"
                                [todosSelected]="todosSelected"
                                [Modelformdata]="Modelformdata"
                                [optimalWallet]="optimalWallet"
                                [asignarCapital]="asignarCapital"
                                [repeticionEntradas]="repeticionEntradas"
                                [editing]="editing"
                                [stopLoss]="stopLoss"
                                [stopLossDinamico]="stopLossDinamico"
                                [stopLossValue]="stopLossValue"
                                [proFit]="proFit"
                                [proFitValue]="proFitValue"
                                [isInValidModel]="isInValidModel"
                                [activatedModelo]="activatedModelo"
                                (changeInputEvent)="changeInput($event.field, $event.event)"
                                (toggleIndiceEvent)="toggleIndice()"
                                (toggleVolatilidadEvent)="toggleVolatilidad()"
                                (buscarCompaniaEvent)="buscarCompania($event)"
                                (registrarCompaniaEvent)="registrarCompania($event.type, $event.event)"
                                (onTodosChangeEvent)="onTodosChange($event)"
                                (actualizarcapitalinicialEvent)="actualizarcapitalinicial()"
                                (startEditingEvent)="startEditing($event)"
                                (finishEditingEvent)="finishEditing($event)"
                              
                                (actualizarSlideStoplossEvent)="actualizarSlideStoploss($event)"
                                (actualizarSlideProfitEvent)="actualizarSlideProfit($event)"
                                (generateModelEvent)="generateModel()"
                                (getFrecuencyEvent)="getFrecuency($event)">
                            </app-crear-modelo>
                    </mat-card-content>
                </mat-card>
            </div>
            <div class="col-md-2 p-0 m-0 resizable-column" style="height: 90%;" #column2 *ngIf="modeloDiv" (mousedown)="startResizing($event, column2)"
                style="width: 400px;">
                <mat-card class="mb-25 enrolled-created-box ccorbit-card no-scrollbar">
                    <mat-card-content class="">
                        <h5 class="etiquetas">Compañias</h5>
                        <app-tabla-compania></app-tabla-compania>
                    </mat-card-content>
                </mat-card>
            </div>

            <div class="col p-0 m-0 ">
                <mat-card class="mb-1 enrolled-created-box ccorbit-card no-scrollbar">
                    <mat-card-content class="">
                        <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" animationDuration="0ms" (selectedTabChange)="onTabChange($event)">
                            <mat-tab>
                                <ng-template mat-tab-label>
                                    Estadisticas
                                    <mat-icon class="tab-help-icon" (click)="showTabHelp('Estadisticas', $event)" matTooltip="Ayuda">help_outline</mat-icon>
                                </ng-template>
                                <mat-card class="mb-25 enrolled-created-box ccorbit-card no-scrollbar">
                                    <mat-card-content class="">
                                        <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start"   animationDuration="0ms">
                                            <mat-tab>
                                                <ng-template mat-tab-label>
                                                    Analisis Estadisticos
                                                    <mat-icon class="tab-help-icon" (click)="showTabHelp('Analisis Estadísticos', $event)" matTooltip="Ayuda">help_outline</mat-icon>
                                                </ng-template>
                                                <app-analisis-estadistico [selectedTab]="selectedTab" [Modelformdata]="Modelformdata"></app-analisis-estadistico>
                                            </mat-tab>
                                            <mat-tab>
                                                <ng-template mat-tab-label>
                                                    Analisis Periodos
                                                    <mat-icon class="tab-help-icon" (click)="showTabHelp('Analisis Periodos', $event)" matTooltip="Ayuda">help_outline</mat-icon>
                                                </ng-template>
                                                <app-analisis-periodos [selectedTab]="selectedTab" ></app-analisis-periodos>
                                            </mat-tab>
                                        </mat-tab-group>
                                    </mat-card-content>
                                </mat-card>

                            </mat-tab>
                            <mat-tab>
                                <ng-template mat-tab-label>
                                    Estudio Earning
                                    <mat-icon class="tab-help-icon" (click)="showTabHelp('Estudio Earning', $event)" matTooltip="Ayuda">help_outline</mat-icon>
                                </ng-template>
                                <app-estudio-earning [selectedTab]="selectedTab"></app-estudio-earning>
                            </mat-tab>
                            <!--mat-tab label="Excel Exclusion" >

                            </mat-tab-->

                        </mat-tab-group>
                    </mat-card-content>
                </mat-card>
            </div>

        </div>
    </div>
</body>